import { TipoEstruturaMoradiaEnum } from "core/resources/enums/tenant";
import axios from "infra/http";
import { useQuery } from "react-query";

function useTenantTipoEstruturaMoradia(tenantId: string) {
  return useQuery(
    `/v1/tenants/${tenantId}/tipo-estrutura-moradia`,
    async () => {
      const { data } = await axios.get<{
        tipoEstruturaMoradia: TipoEstruturaMoradiaEnum;
      }>(`/v1/tenants/${tenantId}/tipo-estrutura-moradia`);

      return data;
    },
    {
      enabled: !!tenantId,
    }
  );
}

export default useTenantTipoEstruturaMoradia;
